/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppModelsDeviceEventScaleChannelReading } from './AppModelsDeviceEventScaleChannelReading';
import {
    AppModelsDeviceEventScaleChannelReadingFromJSON,
    AppModelsDeviceEventScaleChannelReadingFromJSONTyped,
    AppModelsDeviceEventScaleChannelReadingToJSON,
    AppModelsDeviceEventScaleChannelReadingToJSONTyped,
} from './AppModelsDeviceEventScaleChannelReading';

/**
 * 
 * @export
 * @interface WeightReadPayload
 */
export interface WeightReadPayload {
    [key: string]: any | any;
    /**
     * 
     */
    type: WeightReadPayloadTypeEnum;
    /**
     * 
     */
    weightGrams: number;
    /**
     * 
     */
    smoothedWeightGrams: number;
    /**
     * 
     */
    channelReadings?: Array<AppModelsDeviceEventScaleChannelReading> | null;
    /**
     * 
     */
    rawWeightGrams?: number | null;
    /**
     * 
     */
    redistributionFactor?: number | null;
    /**
     * 
     */
    signs?: { [key: string]: number; } | null;
}


/**
 * @export
 */
export const WeightReadPayloadTypeEnum = {
    WeightRead: 'weight_read',
} as const;
export type WeightReadPayloadTypeEnum = typeof WeightReadPayloadTypeEnum[keyof typeof WeightReadPayloadTypeEnum];


/**
 * Check if a given object implements the WeightReadPayload interface.
 */
export function instanceOfWeightReadPayload(value: object): value is WeightReadPayload {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'weight_read') return false;
    
    if ((!('weightGrams' in (value as Record<string, any>)) && !('weight_grams' in (value as Record<string, any>))) || ((value as Record<string, any>)['weightGrams'] === undefined && (value as Record<string, any>)['weight_grams'] === undefined)) return false;
    if ((!('smoothedWeightGrams' in (value as Record<string, any>)) && !('smoothed_weight_grams' in (value as Record<string, any>))) || ((value as Record<string, any>)['smoothedWeightGrams'] === undefined && (value as Record<string, any>)['smoothed_weight_grams'] === undefined)) return false;
    return true;
}

export function WeightReadPayloadFromJSON(json: any): WeightReadPayload {
    return WeightReadPayloadFromJSONTyped(json, false);
}

export function WeightReadPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeightReadPayload {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'type': json['type'],
        'weightGrams': json['weight_grams'],
        'smoothedWeightGrams': json['smoothed_weight_grams'],
        'channelReadings': json['channel_readings'] === undefined ? undefined : json['channel_readings'] === null ? null : ((json['channel_readings'] as Array<any>).map(AppModelsDeviceEventScaleChannelReadingFromJSON)),
        'rawWeightGrams': json['raw_weight_grams'] === undefined ? undefined : json['raw_weight_grams'] === null ? null : json['raw_weight_grams'],
        'redistributionFactor': json['redistribution_factor'] === undefined ? undefined : json['redistribution_factor'] === null ? null : json['redistribution_factor'],
        'signs': json['signs'] === undefined ? undefined : json['signs'] === null ? null : json['signs'],
    };
}

export function WeightReadPayloadToJSON(json: any): WeightReadPayload {
    return WeightReadPayloadToJSONTyped(json, false);
}

export function WeightReadPayloadToJSONTyped(value?: WeightReadPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'type': value['type'],
        'weight_grams': value['weightGrams'],
        'smoothed_weight_grams': value['smoothedWeightGrams'],
        'channel_readings': value['channelReadings'] == null ? undefined : ((value['channelReadings'] as Array<any>).map(AppModelsDeviceEventScaleChannelReadingToJSON)),
        'raw_weight_grams': value['rawWeightGrams'],
        'redistribution_factor': value['redistributionFactor'],
        'signs': value['signs'],
    };
}

